import { useEffect } from 'react';

/**
 * Hook to add noindex meta tags to admin pages for security and SEO
 */
export const useAdminSEO = (title: string = "Admin - Elf Letter Bot") => {
  useEffect(() => {
    // Set page title
    document.title = title;

    // Add or update meta tags to prevent indexing
    const metaElements = [
      { name: 'robots', content: 'noindex,nofollow,noarchive,nosnippet,noimageindex' },
      { name: 'googlebot', content: 'noindex,nofollow,noarchive,nosnippet,noimageindex' },
      { name: 'cache-control', content: 'no-cache, no-store, must-revalidate' },
      { name: 'pragma', content: 'no-cache' },
      { name: 'expires', content: '0' },
      { property: 'og:title', content: title },
      { property: 'og:type', content: 'website' },
      { name: 'twitter:title', content: title }
    ];

    const createdElements: HTMLMetaElement[] = [];

    metaElements.forEach(({ name, property, content }) => {
      const selector = name ? `meta[name="${name}"]` : `meta[property="${property}"]`;
      let meta = document.querySelector(selector) as HTMLMetaElement | null;
      
      if (meta) {
        meta.content = content;
      } else {
        meta = document.createElement('meta');
        if (name) meta.name = name;
        if (property) meta.setAttribute('property', property);
        meta.content = content;
        document.head.appendChild(meta);
        createdElements.push(meta);
      }
    });

    // Remove canonical URL for admin pages
    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.remove();
    }

    // Cleanup function
    return () => {
      createdElements.forEach(el => {
        if (el.parentNode) {
          el.parentNode.removeChild(el);
        }
      });
    };
  }, [title]);
}; 